// extracted by css-extract-rspack-plugin
export default {"StackSectionLoadingSpinner":"StackSection-module__StackSectionLoadingSpinner__ceihJ"};